'use client';
import { ICatalogFilter } from '@/shared/api/getCatalogFilterState/types';
import { useCityStore } from '@/shared/store/cityStore';
import { useFiltersStore } from '@/shared/store/filtersStore';
import { Button } from '@/shared/ui/Button';
import CheckToggler from '@/shared/ui/CheckToggler/ui/CheckToggler';
import { CountBadge } from '@/shared/ui/CountBadge';
import { Dropdown } from '@/shared/ui/Dropdown/Dropdown';
import { Portal } from '@/shared/ui/Portal';
import { twMergeExt } from '@/shared/utils/twMergeExt';
import FiltersPopup from '@/widgets/FiltersPopup/ui/FiltersPopup';
import { cva } from 'class-variance-authority';
import { AnimatePresence } from 'framer-motion';
import { FC, useEffect, useState } from 'react';
import BurgerSmallIcon from '~/icons/burger-small.svg';

interface Props {
  className?: string;
  fieldProps: any;
  onOpenNaznachenie?: (value: boolean) => void;
  filters: ICatalogFilter[];
  onShopChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  initialSectionId?: number;
  initialLabel?: number;
  setFilterStateForQuery: (value: any) => void;
  isLoading?: boolean;
  manualShopChange?: (value: string | number, checked: boolean) => void;
}

export const CatalogCategoryFilters: FC<Props> = ({
  className,
  filters,
  onShopChange,
  initialSectionId,
  isLoading,
  fieldProps,
  onOpenNaznachenie,
  initialLabel,
  manualShopChange,
  setFilterStateForQuery,
}) => {
  const totalSelectedFilters = useFiltersStore((state) => state.getTotalSelectedFilters());
  const [isFiltersPopupOpen, setIsFiltersPopupOpen] = useState(false);
  const city = useCityStore((state) => state.city);
  const filtersState = useFiltersStore((state) => state.filters);
  const cityShops = useCityStore((state) => state.shops);
  const getCityShops = useCityStore((state) => state.getCityShops);
  const getFilterShopIds = useFiltersStore((state) => state.getShopIds);
  const getFilterStateBody = useFiltersStore((state) => state.getFilterBody);
  // const setShopId = useFiltersStore(
  //   (state) => state.setShopId
  // );
  const cityHasShops = useCityStore((state) => state.cityHasShops);

  const allStoresIds = useCityStore((state) => state.allStoresIds);

  useEffect(() => {
    getCityShops(city);
  }, [city]);

  // const handleCheckboxAvailabilityChange = (e: React.ChangeEvent<HTMLInputElement>) => {
  //   const { checked } = e.target;

  //   if (checked) {
  //     cityShops?.forEach((shop) => {
  //       setShopId(shop.store_id, true);
  //     });
  //   } else {
  //     cityShops?.forEach((shop) => {
  //       setShopId(shop.store_id, false);
  //     });
  //   }
  // };

  const setFilter = useFiltersStore((state) => state.setFilter);

  const handleCheckBoxExpressDeliveryChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { checked } = e.target;
    if (checked) {
      setFilter('expressDelivery', '1', true);
      setFilterStateForQuery(getFilterStateBody());
    } else {
      setFilter('expressDelivery', '1', false);
      setFilterStateForQuery(getFilterStateBody());
    }
  };

  const shopAutoSelect = () => {
    if (!cityShops.length || cityShops?.length > 1) {
      return;
    }

    if (manualShopChange) {
      manualShopChange(cityShops[0].store_id, true);
    }
  };

  // const {
  //   data: allShops,
  //   isFetching: isLoading2,
  // } = useQuery({
  //   queryKey: ['allShops'],
  //   queryFn: () => {
  //     const res = getShops();
  //     return res;
  //   },
  // });

  const allShopsIds = allStoresIds;

  return (
    <div className={twMergeExt(cvaRoot(), className)}>
      <div className={cvaButtons()}>
        <Button
          className={cvaFiltersButton({
            className: totalSelectedFilters ? '!pr-2.4' : '',
          })}
          hoverEffect={'highlight'}
          wrapperClassName={cvaFiltersButtonWrapper()}
          translateWrapperClassName={cvaFiltersButtonTranslateWrapper()}
          disableInViewAnimation={true}
          color={totalSelectedFilters === 0 ? 'lightGreyOnGreen' : 'lightGreen'}
          onClick={() => setIsFiltersPopupOpen(true)}
        >
          <div className={cvaFiltersButtonInner()}>
            <span className="text-bodyM text-cBlack">Фильтры</span>
            <BurgerSmallIcon className={cvaFiltersButtonBurger()} />
          </div>
          {totalSelectedFilters ? (
            <CountBadge className={cvaFiltersButtonCount()}>{totalSelectedFilters}</CountBadge>
          ) : null}
        </Button>
        {filters.find((item) => item.code === 'NAZNACHENIE')?.values?.length ? (
          <Dropdown
            name={'NAZNACHENIE'}
            data={[]}
            count={fieldProps('NAZNACHENIE')?.value?.length}
            placeholder={'Назначение'}
            className={cvaNaznachenieDropdown()}
            onOpen={(value) => onOpenNaznachenie?.(value)}
            onChange={() => setFilterStateForQuery(getFilterStateBody())}
          />
        ) : null}

        {cityHasShops ? (
          <Dropdown
            name={'shop_ids'}
            data={cityShops?.map((shop) => ({
              id: shop.store_id,
              label: shop.name,
              value: shop.store_id,
            }))}
            multiselect={true}
            searchTitle={'Найти магазин'}
            count={getFilterShopIds().length !== allShopsIds?.length ? getFilterShopIds().length : 0}
            selectInnerClassName={cvaAvailabilityInnerClassName()}
            getIsChecked={getFilterShopIds().length !== allShopsIds?.length ? getFilterShopIds() : []}
            className={cvaAvailabilityDropdown()}
            placeholder={'Наличие в магазинах'}
            onCloseNaznachenie={() => onOpenNaznachenie?.(false)}
            onChange={(e) => {
              onShopChange(e);
              onOpenNaznachenie?.(false);
            }}
            onLoad={shopAutoSelect}
          />
        ) : null}
      </div>
      {cityHasShops ? (
        <CheckToggler
          className={cvaExpress()}
          name={'expressDelivery'}
          value="true"
          checked={
            filtersState.expressDelivery !== undefined &&
            filtersState.expressDelivery &&
            filtersState.expressDelivery.length > 0
          }
          onChange={handleCheckBoxExpressDeliveryChange}
        >
          Экспресс-доставка
        </CheckToggler>
      ) : null}
      <AnimatePresence>
        {isFiltersPopupOpen ? (
          <Portal>
            <FiltersPopup
              onClose={() => {
                setIsFiltersPopupOpen(false);
              }}
              filters={filters}
              initialSectionId={initialSectionId}
              initialLabel={initialLabel}
              isLoading={isLoading}
              setFilterStateForQuery={setFilterStateForQuery}
            />
          </Portal>
        ) : null}
      </AnimatePresence>
    </div>
  );
};

const cvaRoot = cva(['CatalogCategoryFilters-cvaRoot', 'flex items-center gap-3.2', 'text-bodyM']);

const cvaButtons = cva(['CatalogCategoryFilters-cvaButtons', 'flex items-center gap-0.8']);

const cvaFiltersButtonWrapper = cva(['CatalogCategoryFilters-cvaFiltersButtonWrapper', 'relative', 'overflow-visible']);

const cvaFiltersButtonTranslateWrapper = cva([
  'CatalogCategoryFilters-cvaFiltersButtonTranslateWrapper',
  'pr-2 md:pr-0',
]);

const cvaFiltersButton = cva([
  'CatalogCategoryFilters-cvaFiltersButton',
  'flex',
  'pt-0.9 pb-1 md:px-1.6 md:pt-1.1 md:pb-1.3',
  'text-cBlack',
  'rounded-none md:rounded-[1.6rem]',
  'max-[1023px]:bg-transparent',
]);

const cvaFiltersButtonInner = cva([
  'CatalogCategoryFilters-cvaFiltersButtonInner',
  'flex items-center flex-row-reverse md:flex-row gap-0.8',
]);

const cvaFiltersButtonBurger = cva([
  'CatalogCategoryFilters-cvaFiltersButtonBurger',
  'w-1.6 h-1.6 relative left-0 md:top-0.2',
]);

const cvaFiltersButtonCount = cva([
  'CatalogCategoryFilters-cvaFiltersButtonCount',
  'absolute top-0.2 md:top-0 right-0 md:-right-0.8 m-0',
]);

const cvaExpress = cva(['CatalogCategoryFilters-cvaExpress', 'hidden lg:block']);

const cvaNaznachenieDropdown = cva(['CatalogCategoryFilters-cvaNaznachenieDropdown', 'hidden md:block']);

const cvaAvailabilityDropdown = cva(['CatalogCategoryFilters-cvaAvailabilityDropdown', 'hidden md:block']);

const cvaAvailabilityInnerClassName = cva([
  'CatalogCategoryFilters-cvaAvailabilityInnerClassName',
  // 'before:translate-y-0 before:top-1.6',
]);
